export const bidDetailOfferSelector = state => state?.bid?.detail?.data?.offer || {};
export const bidDetailSelector = state => state?.bid?.detail?.data || {};